
  import { Vue, Component, Prop } from "vue-property-decorator";

  import TotalCounter from "@/components/common/TotalCounter.vue";

  @Component({
    components: {
      TotalCounter,
    },
  })
  export default class ActionsPanelWithFilters extends Vue {
    @Prop({ type: Number, required: true }) readonly total!: number;
  }
